<template>
  <div class="main-variant-container" id="selector-main">

    <div v-if="variationGroup.is_dropdown">
      <div class="variant-container variant-container__select active">
        <div :class="`variant-inner-element`">
          <div class="var-content-container">
            <span class="variant-content-text variant-content-text-select">
              {{ product[mainVariable] }}
            </span>
          </div>

          <div class="variant-bottom-row variant-delivery">
          <span
              :class="`c-stock ${product.has_stock === true && product.do_not_display === false ? 'c-instock' : 'c-outstock'}`">
            <p>
              <span v-for="(string, i) in product.delivery_text_array" v-bind:key="i">{{ string }}</span>
            </p>
          </span>
          </div>
        </div>

        <div
            :class="`variant-inner-element variant-inner-element-right selected-right`" v-if="!product.do_not_display">
          <span class="variant-retail-price">

            <span v-if="product.show_retail_price">
              {{ translations['general.MSRP'] }}:
            </span>
            <span v-else>
              {{ product.not_show_retail_price }}:
            </span>


            <span class="variant-retail-price-strike" v-if="product.show_retail_price">
              <span v-if="showCurrency && showCurrencyBeforePrice">
                <span class="currency_before">{{ currencySymbol }}</span>
              </span>
              {{ product.retail_price }}
              <span v-if="showCurrency && !showCurrencyBeforePrice">
                <span class="currency_after">{{ currencySymbol }}</span>
              </span>
            </span>


          </span>

          <div class="variant-bottom-row variant-price">
            <div v-if="showCurrency && showCurrencyBeforePrice">
              <span class="currency_before currency_smaller" v-html="currencySymbol + '&nbsp;'"></span>
            </div>

            {{ product.price.toString().split('.')[0] }}
            <div v-if="product.price.toString().split('.').length > 1" style="display: flex;">
              ,<sup>{{ product.price.toString().split('.')[1] }}</sup>
            </div>

            <div v-if="showCurrency && !showCurrencyBeforePrice">
              <span class="currency_after currency_smaller">&nbsp;{{ currencySymbol }}</span>
            </div>


          </div>
          <div class="c-ppq c-article-spacing" v-if="showPricePerQuantity">
            {{ product.price_per_quantity }}*
          </div>
        </div>
      </div>

      <div class="c-colour-list-container">
        <div class="c-colour-list-button">
          <div class="dx_dropdown-header" @click="dropdownOpen = !dropdownOpen">
            <span>
              {{ product[mainVariable] }}
            </span>
            <div :class="dropdownOpen ? 'dx_svg dx_dropdown-open' : 'dx_svg'" v-html="icons['chevron-down']"></div>
          </div>


        </div>

        <div class="c-colour-dropdown" v-show="dropdownOpen">

          <div v-for="variant in variants" :disabled="!variant.active"
               :class="variant.id === product.id ? 'colour-variation active': 'colour-variation'" :key="variant.id"
               @click="changeVariant(variant)">
            {{ variant[mainVariable] }}
          </div>

        </div>

      </div>
    </div>
    <div v-else-if="variants.length === 1">
      <div class="variant-container variant-container__select active">
        <div class="variant-inner-element selected-left">
          <div class="var-content-container">
            <span class="variant-content-text variant-content-text-select">
              <div v-if="product.is_giftset" class="dx_giftset-container">
                <span v-for="setLine in product.set_lines" :key="setLine">
                  {{ setLine }}
                </span>
              </div>

              <span v-else>
                {{ product.content }}
              </span>
            </span>
          </div>

          <div class="variant-bottom-row variant-delivery">
          <span
              :class="`c-stock ${product.has_stock === true && product.do_not_display === false ? 'c-instock' : 'c-outstock'}`">
            <p>
              <span v-for="(string, i) in product.delivery_text_array" v-bind:key="i">{{ string }}</span>
            </p>
          </span>
          </div>

        </div>

        <div class="variant-inner-element variant-inner-element-right selected-right" v-if="!product.do_not_display">
          <span class="variant-retail-price">
            <span v-if="product.show_retail_price">
              {{ translations['general.MSRP'] }}:
            </span>
            <span v-else>
              {{ product.not_show_retail_price }}:
            </span>


            <span class="variant-retail-price-strike" v-if="product.show_retail_price">
              <span v-if="showCurrency && showCurrencyBeforePrice">
                <span class="currency_before">{{ currencySymbol }}</span>
              </span> 
              {{ product.retail_price }}
              <span v-if="showCurrency && !showCurrencyBeforePrice">
                <span class="currency_after">{{ currencySymbol }}</span>
              </span>
            </span>
          </span>


          <div class="variant-bottom-row variant-price">

            <div v-if="showCurrency && showCurrencyBeforePrice">
              <span class="currency_before currency_smaller" v-html="currencySymbol + '&nbsp;'"></span>
            </div>

            {{ product.price.toString().split('.')[0] }}
            <div v-if="product.price.toString().split('.').length > 1" style="display: flex;">
              ,<sup>{{ product.price.toString().split('.')[1] }}</sup>
            </div>

            <div v-if="showCurrency && !showCurrencyBeforePrice">
              <span class="currency_after currency_smaller">&nbsp;{{ currencySymbol }}</span>
            </div>


          </div>
          <div class="c-ppq c-article-spacing" v-if="showPricePerQuantity">
            {{ product.price_per_quantity }}*
          </div>

        </div>
      </div>

    </div>
    <div v-else>
      <div v-for="variant in variants" v-bind:key="variant.id"
           @click="changeVariant(variant)"
           :class="`variant-container variant-container__select ${variant.id === product.id ? 'active' : ''}`">

        <div :class="`variant-inner-element ${variant.id === product.id ? 'selected-left' : ''}`">
          <div class="var-content-container">
            <input type="radio" v-bind:checked="variant.id === product.id" :value="variant.id"
                   name="variant-select" class="custom-radio">
            <span class="variant-content-text variant-content-text-select">
                {{ variant.content }}
            </span>

          </div>

          <div class="variant-bottom-row variant-delivery">
            <span
                :class="`c-stock ${variant.has_stock === true && variant.do_not_display === false ? 'c-instock' : 'c-outstock'}`">
              <p>
                <span v-for="(string, i) in variant.delivery_text_array" v-bind:key="i">{{ string }}</span>
              </p>
            </span>
          </div>

        </div>

        <div
            :class="`variant-inner-element variant-inner-element-right ${variant.id === product.id ? 'selected-right' : ''}`"
            v-if="!variant.do_not_display">

          <span class="variant-retail-price">
            <span v-if="variant.show_retail_price">
              {{ translations['general.MSRP'] }}:
            </span>
            <span v-else>
              {{ variant.not_show_retail_price }}:
            </span>


            <span class="variant-retail-price-strike" v-if="variant.show_retail_price">
              <span v-if="showCurrency && showCurrencyBeforePrice">
                <span class="currency_before">{{ currencySymbol }}</span>
              </span> 
              {{ variant.retail_price }}
              <span v-if="showCurrency && !showCurrencyBeforePrice">
                <span class="currency_after">{{ currencySymbol }}</span>
              </span>
            </span>
          </span>

          <div class="variant-bottom-row variant-price">
            <div v-if="showCurrency && showCurrencyBeforePrice">
              <span class="currency_before currency_smaller" v-html="currencySymbol + '&nbsp;'"></span>
            </div>

            {{ variant.price.toString().split('.')[0] }}
            <div v-if="variant.price.toString().split('.').length > 1" style="display: flex;">
              ,<sup>{{ variant.price.toString().split('.')[1] }}</sup>
            </div>

            <div v-if="showCurrency && !showCurrencyBeforePrice">
              <span class="currency_after currency_smaller">&nbsp;{{ currencySymbol }}</span>
            </div>


          </div>
          <div class="c-ppq c-article-spacing" v-if="showPricePerQuantity">
            {{ variant.price_per_quantity }}*
          </div>
        </div>
      </div>

    </div>


    <div class="row c-product-main-not-available j-cp-main-na" v-if="product.do_not_display">
      <div class="col-xs-12 j-cp-main-na-text" style="margin-top: 1rem">
        <p>{{ translations['product.18'] }}</p>
        <p>{{ translations['product.19'] }}:</p>
        <form method="post" @submit="submitForm" id="form-alert-me">
          <input type="hidden" name="csrf-token" :value="csrfToken">
          <div class="form-group">
            <input type="hidden" name="product_id" :value="product['id']"/>
            <br/>
            <input type="email" name="inpemail" id="inpemail" class="dx_input"
                   :placeholder="translations['form.email']"/>
            <div class="help-block text-danger" id="not-available-error"></div>
          </div>
          <div class="form-group c-product-not-available__buttons">
            <button type="submit" class="dx_button dx_button-cta c-btn-confirm__email" disabled="true" id="btn-alert">
              <span class="glyphicon glyphicon-envelope"></span>
              &nbsp;
              {{ translations['product.24'] }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="promotion-trigger" v-if="promotionTrigger['show_trigger']">
      <div class="promotion-header">
        <span v-html="promotionTrigger['svg']"></span>
        {{ promotionTrigger['title'] }}
      </div>
      <div>{{ promotionTrigger['text'] }}</div>
    </div>


    <OrderAndWishlist/>

  </div>

</template>

<script>
import OrderAndWishlist from "@/components/OrderAndWishlist";
import $ from 'jquery';

export default {
  name: 'ProductsSelect',
  components: {OrderAndWishlist},
  data: function () {
    return {
      selectedVariant: '',
      dropdownOpen: false,
      initialProductId: null,
      interacted: false
    }
  },
  computed: {
    translations() {
      return this.$store.getters.trans;
    },
    icons() {
      return this.$store.getters.icons;
    },
    showCurrency() {
      return this.$store.getters.currency.show_symbol;
    },
    showCurrencyBeforePrice() {
      return this.$store.getters.currency.show_before_price;
    },
    currencySymbol() {
      return this.$store.getters.currency.symbol;
    },
    showPricePerQuantity() {
      return this.$store.getters.shop.show_price_per_quantity;
    },
    variationGroup() {
      return this.$store.getters.variationGroup;
    },
    promotionTrigger() {
      return this.$store.getters.promotionTrigger;
    },
    mainVariable() {
      return this.variationGroup.main_variable;
    },
    variants() {
      return this.product.variants;
    },
    product() {
      return this.$store.getters.activeProduct
    },
    csrfToken() {
      return document.querySelector('#dx_product-page').dataset.csrf;
    }
  },
  methods: {
    changeVariant(variant) {
      this.dropdownOpen = false;
      variant.variants = this.product.variants;
      window.history.pushState("", variant.name, variant.url);
      this.$store.commit('setActiveProduct', variant);
    },
    markAsInteracted() {
      var btnAlert = document.getElementById("btn-alert");

      if (btnAlert) {
        btnAlert.disabled = false;
      }
      this.interacted = true;
    },
    submitForm(e) {
      var btnAlert = document.getElementById('btn-alert');

      if (btnAlert === null) {
        return;
      }

      btnAlert.disabled = true;

      var naMsg = $(".j-cp-main-na-text");
      var form = naMsg.find("form");


      e.preventDefault();

      var productId = form.find("input[name=product_id]").val();
      var inpemail = form.find("input[name=inpemail]").val();
      var csrfToken = form.find("input[name=csrf-token]").val();
      var url = this.translations['alert-store'];

      var self = this;

      if (inpemail == "") {
        return;
      }

      if (self.interacted === false) {
        // no keyboard or mouse interaction was detected, so any data present must have been filled out programmatically
        //console.log("This form was submitted without keyboard or mouse interaction, which is rather suspicious!");
        return;
      }

      $('#not-available-error').html('');

      let data = {
        product_id: productId,
        inpemail: inpemail,
        'csrf-token': csrfToken
      };

      url += '?alert-confirm=1';

      $.post(url, data, function (data) {
        if (!data.hasErrors) {
          naMsg.html(`${self.translations['product.20']}<br/>${self.translations['product.21']}<br/>`);
        } else {
          var error = data.errors[0];

          if (error.length === 1) {
            naMsg.html(`${self.translations['product.22']}<br/>${self.translations['product.23']}`)
          } else {
            $('#not-available-error').html(error);
          }

          btnAlert.disabled = false;
        }
      });
    }
  },
  mounted() {
    this.initialProductId = this.product.id;
    const self = this;
    addEventListener('mousemove', () => self.markAsInteracted());
    addEventListener('keypress', () => self.markAsInteracted());

  }
}
</script>
